import o from "@rpldy/upload-drop-zone";
import t from "styled-components";
import e from "../../../utils/colors.js";
const a = t.div``, s = t(o)`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 0px;
  border-radius: 2px;
  max-height: 136px;
  outline: none;
  transition: border 0.24s ease-in-out;
  background-color: ${(i) => i.disabled ? e.darkGrey10 : e.white};
  border: 2px dashed ${(i) => i.disabled ? e.darkGrey75 : e.blueGrey};
  box-sizing: content-box; // normally not needed to be explicit, but SiteCore has a different base style
`, d = t.div`
  display: flex;
  align-items: center;
  max-width: 233px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.32px;
  color: ${e.blueGrey};

  // The margin is set normally, but this is adding it explicitly as Sitecore has a different base style
  > ul {
    margin: 16px 0;

    > li {
      // Sitecore override...
      font-family: 'VIC';
    }
  }
`, p = t.div`
  color: ${e.blueGrey};
  letter-spacing: -0.24px;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  height: 24px;
`;
export {
  a as BaseWrapper,
  d as ListContainer,
  p as TitleContainer,
  s as Wrapper
};
